<svelte:head>
  <title>Operations | A Good Thing</title>
</svelte:head>

<!-- Main container -->
<nav class="level">
  <!-- Left side -->
  <div class="level-left">
    <div class="level-item">
      <h2 class="title">Operations</h2>
    </div>
  </div>

  <!-- Right side -->
  <div class="level-right"><button class="button">More actions</button></div>
</nav>

<article class="message is-info">
  <div class="message-body">
    <p>Advanced operations</p>
  </div>
</article>

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => (showToast = false)} />
    {message}
  </div>
{/if}

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="operation" class="label">Operation</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <div class="select">
          <select id="operation" bind:value={operation}>
            <option>Select operation</option>
            <!-- insert function names here -->
            <!-- <option value="updateCharityRecords">updateCharityRecords</option> -->
            <option value="admin-sendnotifications">sendNotifications</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="data" class="label">Data</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <textarea
          class="textarea"
          placeholder=""
          rows="10"
          bind:value={payloadJson}
        />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          class:is-loading={isLoading}
          on:click={() => apply()}>Run</button
        >
      </div>
    </div>
  </div>
</div>

<script>
  import _ from "lodash";

  let operation;
  let payloadJson = '';

  let message;

  let isLoading = false;

  let showToast = false;

  async function apply() {
    let firebase = window.firebase;

    let payload;
    
    try {
      payload = JSON.parse(payloadJson);
    } catch (err) {
      message = err.message;
    }

    isLoading = true;
    await firebase
      .functions()
      .httpsCallable(operation)(payload)
      .then(() => {
        message = "Completed without errors.";
      })
      .catch((err) => {
        message = err;
      })
      .finally(() => (isLoading = false));

    showToast = true;
  }
</script>
